export default {"src":"/_next/static/media/goals.3c348b7b.svg","height":157,"width":243};